import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '../store/authStore'
import { ROUTES } from '@shared/constants'
import LoadingSpinner from './LoadingSpinner'

interface ProtectedRouteProps {
    children: React.ReactNode
}


/**
 * Route guard that redirects unauthenticated users to login.
 * Enforces email verification before accessing protected content.
 * Checks for account locks on mount and shows support modal if locked.
 */

export default function ProtectedRoute({ children }: ProtectedRouteProps) {

  const { user, isLoading } = useAuthStore()
  const location = useLocation()

  // During initial auth check, don't render protected content.
  // Rendering children here can cause brief flashes of in-app banners/UI on hard reload.
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-950">
        <LoadingSpinner size="large" />
      </div>
    )
  }

  // Once auth check finishes, enforce protection
  if (!user) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />
  }

  if (!user.emailVerified) {
    return <Navigate to={ROUTES.VERIFY_EMAIL} replace />
  }

  return <>{children}</>
}
